import { PresetSchema } from "@redotech/redo-fulfillment-parcel-common/presets";
import * as z from "zod";

export const getPresets = {
  name: "getPresets" as const,
  input: z.object({}),
  output: z.object({ presets: z.array(PresetSchema) }),
};
